import { type DamAncestry } from '../../models/DamAncestry';

const DamAncestryDisplay = ({ damAncestry }: { damAncestry: DamAncestry }) => {
  return (
    <div className='sire-ancestry'>
      {damAncestry && (
        <div className='ancestry-display'>
          <p className='sire-dam dam-underline'>{damAncestry.dam}</p>
          <p className='second-generation-sire sire-underline'>
            {damAncestry.sireParent1}
          </p>
          <p className='second-generation-dam dam-underline'>
            {damAncestry.damParent1}
          </p>
          <p className='third-generation-sire-sire sire-underline'>
            {damAncestry.sireParent2}
          </p>
          <p className='third-generation-dam-sire dam-underline'>
            {damAncestry.damParent2}
          </p>
          <p className='third-generation-sire-dam sire-underline'>
            {damAncestry.sireParent3}
          </p>
          <p className='third-generation-dam-dam dam-underline'>
            {damAncestry.damParent3}
          </p>
        </div>
      )}
    </div>
  );
};

export default DamAncestryDisplay;
